import {gsap} from "gsap";
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import Swiper from 'swiper/bundle';

gsap.registerPlugin(ScrollTrigger);

let stickyHeight = $('.single-blog .content-right-text').outerHeight(true);
const featureImgs = gsap.utils.toArray(".single-blog .wrap-for-scrollTrigger");

featureImgs.forEach((img, i) => {
    const pinEl = $(img).find('.content-right-text');

    setTimeout(() => {
        gsap.to(img, {
            scrollTrigger: {
                trigger: '.wrap-for-scrollTrigger',
                scrub: true,
                pin: pinEl,
                start: "top top",
                end: "bottom center",
                toggleClass: "active",
                pinSpacing: false,
                duration: stickyHeight
            },
            duration: stickyHeight
        });
    }, 800);
});


(function ($) {

    //swiper
    let swiper = new Swiper(".section-slider-with-other-blogs-this-category .slider-blocks", {
        slidesPerView: 'auto',
        navigation: {
            nextEl: ".section-slider-with-other-blogs-this-category .swiper-button-next",
            prevEl: ".section-slider-with-other-blogs-this-category .swiper-button-prev",
        },
        pagination: {
            el: ".section-slider-with-other-blogs-this-category .swiper-pagination",
            clickable: true,
        }
    });
})(jQuery);